module.exports = __webpack_public_path__ + "static/img/liulan.e0538b04.png";